export const checkPhone = (rule, value, callback) => {
	callback();
	// const phoneRegex = /^\s*\d{2,14}([-\s]\d{2,14})*\s*$/
	// if (!value) {
	//   callback()
	// } else if (phoneRegex.test(value)) {
	//   callback()
	// } else {
	//   callback(new Error('Numéro invalide (ex : 0612345678'))
	// }
};

export const validatePrefix = (rule, value, callback, phone) => {
	if (!phone) {
		callback();
	}
	const regex = /^\+[0-9]{1,4}$/;
	if (!value) {
		callback(new Error("Invalide"));
	} else if (!regex.test(value)) {
		callback(new Error("Invalide"));
	} else {
		callback();
	}
};
